<template>
  <div class="administrator-panel">

    <div class="admin-hit fixed-top d-flex flex-column flex-md-row align-items-center p-3 px-md-4 mr-100 bg-white border-bottom shadow-sm" style="margin-right: 100px">
      <div class="col-6 my-0 mr-md-auto font-weight-normal"><span class="m-none" style="margin-right: 10px">Antwerk Panel </span>
        <a @click="logOut" href="#" class="btn btn-outline-primary">Exit panel</a>
        <button @click="seoEditModal" class="btn btn-outline-success my-2 my-sm-0" data-toggle="modal" data-target="#seo-modal" type="submit">SEO edit</button>
        <a @click="chagePostStatus" v-if="$route.name == 'post'" href="#" v-bind:class="{'btn-outline-info': post.status == 'draft','btn-outline-danger': post.status == 'publish'}" class="btn">{{post.status == 'publish' ? 'Unpublish' : 'Publish'}}</a>
        <router-link v-if="$route.name == 'news'" to="/news/addpost" class="btn btn-outline-primary add-post">Write Post</router-link>
      </div>
      <div v-for="error in errors" class="col-3 alert alert-danger show left fade" role="alert">{{error.message}}</div>
      <div v-show="success" v-bind:class="{'show' : success}" class="col-3 alert alert-success left fade" role="alert">Save changes have been made</div>
      <div class="col-2 text-right">
        <a @click="saveChanges" href="#" class="btn btn-success"><span class="fi-check"></span> Save changes</a>
      </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="seo-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Seo editor</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div v-show="metaSuccess" v-bind:class="{'show' : metaSuccess}" class="col-12 alert alert-success left fade" role="alert">Save changes have been made</div>
            <form @submit="saveMeta">
              <input type="hidden" name="id" v-model="metaId" />
              <input type="hidden" name="lang" v-model="metaLang" />
              <input type="hidden" name="page" v-model="metaPage" />
              <input type="hidden" name="url" v-model="post.url" />
              <div class="form-group">
                <label for="meta-title">Meta-title</label>
                <input type="text" v-model="metaTitle" name="meta_title" class="form-control" id="meta-title" aria-describedby="text" placeholder="Enter page meta title" value="">
              </div>
              <div class="form-group">
                <label for="meta-description">Meta-description</label>
                <textarea class="form-control" v-model="metaDescription" name="meta_description" placeholder="Enter meta description" id="meta-description" rows="3"></textarea>
              </div>
              <div class="text-right">
                <button @click="saveMeta" type="submit" class="btn btn-primary text-right">Save</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div class="m-b-s" style="margin-bottom: 60px"></div>

  </div>
</template>

<script>

import {HTTP} from '../http-common'

export default {
  name: 'Panel',

  data() {
    return {
      success: false,
      metaSuccess: false,
      metaTitle: '',
      metaDescription: '',
      metaId: 0,
      metaLang: 0,
      metaPage: '',
      post: {
        status: 'publish',
        url: ''
      },
      errors: []
    }
  },

  watch: {
    'errors': function() {
      // console.log(this.errors)
    }
  },

  created() {
    this.$root.$on('post_update', data => {
      this.post.status = data.status
      this.post.url = data.url
    })
  },

  mounted() {
    document.querySelectorAll('[data-key]').forEach(function(node){
      node.contentEditable = true
    })
  },

  methods: {
    saveChanges(event) {
      event.preventDefault()

      if (this.$route.name == 'admin') {
        $('#hf-info-form input[type="submit"]').trigger('click')

        this.success = true

        this.errors = []

        setTimeout(() => {
          this.success = false
          location.reload()
        }, 1000)

        return;
      }

      let page = $('main').data()

      page.posts = ''
      page.json = {}

      $('[data-key]').each(function(){
        let key = $(this).data('key'),
            value = ''

        if ($(this)[0].nodeName.toLowerCase() == 'input' || $(this)[0].nodeName.toLowerCase() == 'textarea')
          value = $(this).val()
        else if ($(this).data('type') == 'editor')
          value = $(this).summernote('code')
        else
          value = $(this).html()

        if (key.indexOf('.') != -1) {
          let parts = key.split('.')

          if (!page.json[parts[0]])
            page.json[parts[0]] = {}

          page.json[parts[0]][parts[1]] = value
        } else if (key.indexOf('#') != -1) {
          let parts = key.split('#')

          if (!page.json[parts[0]])
            page.json[parts[0]] = []

          if (parts.length > 2) {
            if (!page.json[parts[0]][parts[1]])
              page.json[parts[0]][parts[1]] = {}

            page.json[parts[0]][parts[1]][parts[2]] = value
          } else {
            page.json[parts[0]][parts[1]] = value
          }
        } else {
          page.json[key] = value
        }
      })

      if (['post', 'service_page', 'new_post'].indexOf(page.page) != -1) {
        page.title = page.json.title
        page.subtitle = page.json.subtitle
        page.content = page.json.content
        page.url = page.json.url
        page.image = page.json.image
        page.metaTitle = page.json.meta_title || ''
        page.meta_description  = page.json.meta_description || ''
        page.type = page.page == 'service_page' ? 'service_page' : 'news'
        page.language_id = page.language || 0
      }

      /**/console.log(page)/**/

      page.json = JSON.stringify(page.json)

      if (page.page == 'new_post') {
        this.errors = []

        if (!page.url.length) {
          this.errors.push({message: 'Необходимо указать Post URL!'})
        } else {
          HTTP.get('pages?filter[where][name]=news').then(response => {
            var addedPosts = response.data.length

            response.data.forEach(parent => {
              HTTP.post('posts?access_token=' + this.$root.accessToken, {
                language_id: parent.language_id,
                page_id: parent.id,
                type: page.type,
                title: page.title,
                subtitle: page.subtitle,
                content: page.content,
                json: page.json,
                content_short: '',
                meta_title: '',
                meta_description: '',
                image: page.image,
                url: page.url
              }).then(response => {
                if (response.status && response.status == 200) {
                  if (--addedPosts == 0) {
                    this.success = true

                    this.errors = []

                    setTimeout(() => {
                      this.success = false
                      location.reload()
                    }, 1000)
                  }
                }
              }).catch(e => {
                this.errors = []
                this.errors.push(e.response.data.error)
              })
            })
          }).catch(e => {
            this.errors = []
            this.errors.push(e.response.data.error)
          })
        }
      } else {
        HTTP.patch((['post', 'service_page'].indexOf(page.page) != -1 ? 'posts/' : 'pages/' + page.id) + '?access_token=' + this.$root.accessToken, page).then(response => {
          if (response.status && response.status == 200) {
            this.success = true

            this.errors = []

            setTimeout(() => {
              this.success = false
              location.reload()
            }, 1000)
          }
        }).catch(e => {
          this.errors = []
          this.errors.push(e.response.data.error)
        })
      }
      //*/
    },

    saveMeta(event) {
      event.preventDefault();

      let data = {
        meta_title: this.metaTitle || '',
        meta_description: this.metaDescription || '',
        language_id: this.metaLang,
        url: location.href.split('/').pop(),
        id: this.metaId
      }

      HTTP.patch((['post', 'service_page'].indexOf(this.metaPage) != -1 ? 'posts/' : 'pages/' + this.metaId) + '?access_token=' + this.$root.accessToken, data).then(response => {
        if (response.status && response.status == 200) {
          this.metaSuccess = true

          this.errors = []

          setTimeout(() => {
            this.metaSuccess = false
          }, 1000)
        }
      }).catch(e => {
        this.errors = []
        this.errors.push(e.response.data.error)
      })
      // console.log(this)
    },

    seoEditModal(event) {
      let page = $('main').data()

      this.metaId = page.id
      this.metaLang = page.language
      this.metaPage = page.page


      this.metaTitle = document.querySelector('title').text
      this.metaDescription = document.querySelector('meta[name="description"]').text
    },

    chagePostStatus(event) {
      event.preventDefault()

      HTTP.get('posts?filter[where][url]=' + this.post.url).then(response => {
        if (response.status && response.status == 200) {
          var needUpdate = response.data.length,
              newStatus = this.post.status == 'publish' ? 'draft' : 'publish'

          response.data.forEach((post) => {
            HTTP.patch('posts/' + post.id + '?access_token=' + this.$root.accessToken, {
              status: newStatus,
              language_id: post.language_id,
              url: post.url,
              id: post.id
            }).then(response => {
              if (response.status && response.status == 200) {
                if (--needUpdate == 0) {
                  this.errors = []
                  this.success = true

                  this.post.status = newStatus

                  setTimeout(() => {
                    this.success = false
                    // location.reload()
                  }, 1000)
                }
              }
            }).catch(e => {
              this.errors = []
              this.errors.push(e)
            })
          })
        }
      }).catch(e => {
        this.errors = []
        this.errors.push(e)
      })
    },

    logOut(event) {
      event.preventDefault()

      localStorage.clear()
      location.reload()
    }
  }
}

</script>

<style scoped>

.administrator-panel .alert.alert-success.left,
.administrator-panel .alert.alert-danger.left {
  font-size: 15px;
  padding: 7px 10px;
  float: left;
  margin-bottom: 0;
  text-align: center;
}

.add-post {
  margin-left: 10px;
}

.btn + .btn {
  margin-left: 10px;
}

@media (max-width: 1023px) { 
  .administrator-panel{
    display: none !important;
  }
  .admin-hit{
    margin-right: 10px !important;
  }
  .admin-hit .btn{
    font-size: 12px;
    padding: 6px 6px;
    margin-bottom: 0;
  }
  .m-none{
    display: none;
  }
  .m-b-s{
    margin-bottom: 0 !important;
  }
}

</style>